module.exports = __webpack_public_path__ + "static/mm_logo-f67565450ff9a3c29c5a73f01a58ea72.png";